import React, { useState } from 'react';
import './UniversityExistsDialog.css';

/**
 * When a university exists for the user's domain: offer to create an on-campus org (instant) or request access to the university.
 */
const UniversityExistsDialog = ({
  universityName,
  onCreateOnCampus,
  onRequestAccess,
  onCancel,
}) => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [orgName, setOrgName] = useState('');
  const [requestedByName, setRequestedByName] = useState('');
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!orgName.trim()) newErrors.orgName = 'Organization name is required';
    if (!requestedByName.trim()) newErrors.requestedByName = 'Your name is required';
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setSubmitting(true);
    try {
      await onCreateOnCampus(orgName.trim(), requestedByName.trim());
    } finally {
      setSubmitting(false);
    }
  };

  if (showCreateForm) {
    return (
      <div className="dialog-overlay university-exists-overlay">
        <div className="dialog-content university-exists-content">
          <h2>Create on-campus organization</h2>
          <p className="dialog-question">
            Your school pays for SyllySync. Create an organization for your group at no cost.
          </p>
          <form onSubmit={handleCreateSubmit}>
            <div className="form-group">
              <label htmlFor="uco-orgName">Organization name <span className="required">*</span></label>
              <input
                id="uco-orgName"
                type="text"
                value={orgName}
                onChange={(e) => {
                  setOrgName(e.target.value);
                  if (errors.orgName) setErrors((prev) => ({ ...prev, orgName: null }));
                }}
                placeholder="e.g., Chess Club"
                className={errors.orgName ? 'error' : ''}
              />
              {errors.orgName && <span className="error-message">{errors.orgName}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="uco-requestedByName">Your name <span className="required">*</span></label>
              <input
                id="uco-requestedByName"
                type="text"
                value={requestedByName}
                onChange={(e) => {
                  setRequestedByName(e.target.value);
                  if (errors.requestedByName) setErrors((prev) => ({ ...prev, requestedByName: null }));
                }}
                placeholder="e.g., Jane Smith"
                className={errors.requestedByName ? 'error' : ''}
              />
              {errors.requestedByName && <span className="error-message">{errors.requestedByName}</span>}
            </div>
            <div className="dialog-buttons">
              <button type="button" onClick={() => setShowCreateForm(false)} className="dialog-button cancel-button">
                Back
              </button>
              <button type="submit" className="dialog-button submit-button" disabled={submitting}>
                {submitting ? 'Creating…' : 'Create organization'}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="dialog-overlay university-exists-overlay">
      <div className="dialog-content university-exists-content">
        <h2>Your school has SyllySync</h2>
        <p className="dialog-question">
          {universityName ? (
            <>A university account exists for your domain. You can create an on-campus organization for free or request access to the main account.</>
          ) : (
            <>A university account exists for your domain. You can create an on-campus organization for free or request access to the main account.</>
          )}
        </p>
        <div className="dialog-buttons university-exists-buttons">
          <button
            type="button"
            className="dialog-button primary-button"
            onClick={() => setShowCreateForm(true)}
          >
            Create on-campus organization (free)
          </button>
          <button
            type="button"
            className="dialog-button secondary-button"
            onClick={onRequestAccess}
          >
            Request access to university account
          </button>
          <button type="button" onClick={onCancel} className="dialog-button cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UniversityExistsDialog;
